import * as Enum from "@/assets/js/enum";
export default {
  methods: {
    isPending(status) {
      return status === Enum.BillingStatusType.PENDING.code;
    },
    isTemp(status) {
      return status === Enum.BillingStatusType.TEMPORARY_CONFIRMED.code;
    },
    isPublished(status) {
      return status === Enum.BillingStatusType.PUBLISHED.code;
    },
    isConfirmed(status) {
      return status === Enum.BillingStatusType.CONFIRMED.code;
    }
  }
};
